import { MdError } from 'react-icons/md';
import { useCredits } from '../../state';
import { Code } from '../code';
import { colors } from '../../constants';

export const CreditBalance = () => {
  const { credits, loading } = useCredits();

  if (!credits?.usd) {
    return;
  }

  const negative = credits.usd.remaining < 0;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
      {negative && <MdError size={18} color={colors.error} />}
      <Code
        style={
          negative
            ? {
                backgroundColor: colors.error,
                color: 'white',
                borderRadius: 5,
                fontWeight: 'bold',
              }
            : {}
        }
        language="text"
        inline
        code={'$' + credits.usd.remaining}
      ></Code>
    </div>
  );
};
